module.exports = __webpack_public_path__ + "img/baseball-bat-ball.0a544de0.svg";